import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LiftLine from "./components/LiftLine";

const Lift2 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift2" className={getLiftClass(isOpen, activeLiftId === '2', state)}
			 transform="translate(1058.000000, 695.000000)"
		>
			<LiftLine x1="250.5" y1="160.5" x2="373.5" y2="238.5" color={colors[0]}/>

			<LiftLabelTypeSeat
				seatCount="2"
				colors={getLiftStatusColors(state, isOpen)}
				isOpen={isOpen}
				coords="304.000000, 194.000000"/>

			<LiftLine x1="13.5" y1="13.5" x2="160.5" y2="104.5" color={colors[0]}/>

			<g id="Labe-lift">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
				<g strokeWidth="1" transform="translate(9.000000, 4.000000)"
					 fill={colors[2]} fontFamily="OpenSans-Bold, Open Sans" fontSize="12"
					 fontWeight="bold">
					<g>
						<text>
							<tspan x="0.0751953125" y="13">2</tspan>
						</text>
					</g>
				</g>
			</g>

			<g id="Labe-lift" transform="translate(360.000000, 225.000000)">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(372.500000, 237.500000) scale(-1, 1) rotate(-216.000000) translate(-372.500000, -237.500000) "
				points="367 237.5 378 232 375.628513 237.5 378 243"/>
		</g>
	);
};

Lift2.propTypes = {};

export default Lift2;
